import React from 'react';

function ProvaTitle({ bundleInfo, hores, castell, versio }) {
    return (
        <div className="prova-title">
            <div className="title-main">
                {bundleInfo?.nom || castell}
            </div>
            {hores && (
                <div className="title-time">
                    {hores[0]} - {hores[1]}
                </div>
            )}

            <style jsx>{`
                .prova-title {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 0.5rem;
                    border-radius: 4px;
                }

                .title-main {
                    font-weight: bold;
                }

                .title-version {
                    color: #666;
                    font-size: 0.9em;
                }

                .title-time {
                    color: #666;
                    font-size: 0.9em;
                    padding-left: 0.5rem;
                    border-left: 1px solid #ddd;
                }
            `}</style>
        </div>
    );
}

export default ProvaTitle; 